import { FilterList } from "../../../Rank/style/filter";
import {
  EventScheduleFilterItemWrapper,
  EventScheduleFilterList,
} from "./style";

export interface EventScheduleFilterProps {
  open: boolean;
  setOpen: (v: boolean) => void;
  setOtherOpen: (v: boolean) => void;
  filterList: FilterDto[];
  label: string;
  selectedItem: FilterDto;
  setSelectedItem: (v: FilterDto) => void;
  setDate: (v: string) => void;
}

export interface FilterDto {
  id: number;
  name: string;
}
const EventScheduleFilter = ({
  open,
  setOpen,
  setOtherOpen,
  filterList,
  label,
  selectedItem,
  setSelectedItem,
  setDate,
}: EventScheduleFilterProps) => {
  return (
    <EventScheduleFilterItemWrapper
      onClick={() => {
        setOpen(!open);
        setOtherOpen(false);
      }}
    >
      {selectedItem.name.replace("러너펍", "").trim()}
      <img src="/image-web/rank/down-arrow.svg" alt="down" />
      {open && (
        <EventScheduleFilterList>
          {filterList.map((item, index) => (
            <div
              className={`item ${selectedItem.id === item.id ? "select" : ""}`}
              key={index}
              onClick={() => {
                setSelectedItem(item);
                setDate("");
              }}
            >
              {item.id === -1 ? label : item.name.replace("러너펍", "").trim()}
            </div>
          ))}
        </EventScheduleFilterList>
      )}
    </EventScheduleFilterItemWrapper>
  );
};

export default EventScheduleFilter;
